export default {
  en: {
    E_1: 'nonlicet token',
    '100000': 'System error.',
    '100001': 'The country was not found!',
    '100002': 'The province was not found!',
    '100003': 'The city was not found!',
    '100004': 'The district was not found!',
    '100005':
      'Failed to verify. Please check if the time is out or verification code is correct!',
    '100006':
      'A verification code has been sent to the phone, please check it!',
    '100007': 'Organization type was not found!',
    '100008': 'Sorry, this account was not found!',
    '100009':
      'The student account is not activated. Please log in to the Future Classroom to activate it before adjusting the classroom performance score!',
    '100010': 'For your account security, please log in again!',
    '100011': 'Sorry, the data is not found!',
    '100012': 'Submission of wrong information! Please check and submit again!',
    '100013': 'Failed to send verification code!',
    '100014': 'Failed to access!',
    '100016': 'Unknown exception!',
    '200001': 'The administrator account is wrong!',
    '200002': 'The administrator password is wrong!',
    '200004': 'Application information not found!',
    '200005': 'Organization not found!',
    '200006': 'The teacher already exists!',
    '200007': 'User not found.',
    '200008': 'The applicant is a student and cannot be submitted!',
    '200009': 'Wrong username or password!',
    '200010': 'Sorry! This application has been processed!',
    '200011': 'Bcm file not found!',
    '200012': 'Tutor cannot modify the name of the organization.',
    '200013': 'Add more than 50 students at a time, please check and add.',
    '210009': 'User not found.',
    '210013': 'PID error',
    '210014': 'User is locked',
    '210015': 'Wrong account or password',
    '210016': 'Error activation',
    '210017': 'Activation failure',
    '300001': 'Sorry! Class is not found!',
    '300002': 'Sorry! You do not have the Future Classroom permission!',
    '300003': 'The number of registration students should not exceed 100!',
    '300004': 'The number of students in each class should not exceed 200!',
    '300005': 'Sorry! The user already exists in other institutions!',
    '300006': 'This user is not a student!',
    '300007': 'The student is already in the current class!',
    '300008': 'Sorry! You do not have this permission yet!',
    '300009': 'Sorry! The number of class should not exceed 200!',
    '300010':
      'Sorry! You requested a verification code too often! Please try again later!',
    '300011':
      'Sorry! This phone number has been used! Please change your mobile number!',
    '300012':
      "You have already bound your phone number and don't need to do it again!",
    '300013': 'Not your mobile phone number.',
    '300014': 'Failed to cancel teacher permission.',
    '300015': 'Failed to restore teacher permission.',
    '400001':
      'System updating! If the system is always in this status, please contact the staff!',
    '500010': 'There is news under the column. It cannot be deleted.',
    '500011': 'Under the column, the headline news cannot exceed 5.',
    '520001': 'There are more than 10 new ads.',
    '520002': 'Ads which is publishing cannot be deleted.',
    '520003': 'There must be one left for the removed advertisement.',
    '530001': 'The overall list is not open yet.',
    '530002': 'The overall list is open.',
    '550001': 'Channel can not filter data.',
    '560001': 'There are more than 10 new events.',
    '560002': 'Automatic removal/published time must exist at the same time.',
    '570001': 'User does not set password for the first time.',
    '550002': 'The channel already exists and cannot be submitted repeatedly.',
    '610000': 'User cannot bind new organization.',
    '620000': 'Failed to save organization course.',
    '620001': 'Failed to cancel organization course.',
    '621001': 'Failed to add student course.',
    '621002': 'Failed to cancel student course.',
    '630000': 'Failed add a course package record.',
    '630001': 'Failed to update.',
    '630002': 'Failed to add course.',
    '630003': 'Failed to update course.',
    '630004': 'Failed to update course introduction.',
    '630005': 'Failed to update course notes.',
    '630006': 'Failed to delete course package record.',
    '630007': 'Course package record does not exist.',
    '630008':
      'The creating tool is inconsistent with the material format and cannot be saved.',
    '630009': 'Creating tool unavailable.',
    '630010': 'Creating tools required.',
    '630011': 'This course has more than 200 sessions.',
    '630012': 'Failed to delete course.',
    '630013': 'Failed to send course.',
    '630014': 'The course package has courses and cannot be deleted.',
    '700000': 'Failed to grade.',
    '910001': 'email has been enrolled',
    '910005': 'email sending too often',
    '910006': 'email not registered',
    '400002': 'Username cannot have special characters.',
    '400003': 'The phone number has been bound to other user.',
    '400004': 'Failed to reset password.',
    '910007': 'Service exception'
  },
  'zh-CN': {
    E_1: '非法token',
    '100000': '系统错误',
    '100001': '未找到该国家!',
    '100002': '未找到该省份!',
    '100003': '未找到该城市!',
    '100004': '未找到该区县!',
    '100005': '验证失败，请检查是否超时或验证码输入是否正确!',
    '100006': '已发送验证码至手机，请及时查看!',
    '100007': '单位类型未找到!',
    '100008': '抱歉，未找到此账号!',
    '100009': '该学生尚未登录过未来教室，账号未激活，请先激活再调整课堂表现分!',
    '100010': '为了您的账号安全，请重新登录！',
    '100011': '抱歉，未查询到相应数据！',
    '100012': '提交信息错误！请检查再提交！',
    '100013': '验证码发送失败!',
    '100014': '获取失败!',
    '100016': '未知异常!',
    '200001': '管理员账号错误！',
    '200002': '管理员密码错误！',
    '200004': '申请信息未找到！',
    '200005': '单位未找到！',
    '200006': '该老师已存在！',
    '200007': '用户未找到',
    '200008': '申请人是学生，不能提交哦！',
    '200009': '用户名或密码错误！',
    '200010': '抱歉！此申请已被处理过！',
    '200011': '未找到BCM文件!',
    '200012': '教管不能修改单位名称',
    '200013': '批量添加学生超过50个，请检查再添加',
    '200014': '有账号未找到，请检查再添加',
    '210009': '用户不存在',
    '210013': 'PID 错误',
    '210014': '用户被锁定',
    '210015': '账号或密码错误',
    '210016': '激活错误',
    '210017': '激活失效',
    '300001': '抱歉！班级未找到！',
    '300002': '抱歉！您尚未有“未来教室”权限！',
    '300003': '一次批量注册学生人数需不超过100人哦 ！',
    '300004': '班级学生人数需不超过200人哦！',
    '300005': '抱歉！用户已经存在于其他机构！',
    '300006': '此用户非学生身份哦！',
    '300007': '学生已在当前班级！',
    '300008': '抱歉！您尚未有此权限！',
    '300009': '抱歉！班级数需不超过200个哦！',
    '300010': '抱歉！您请求验证码过于频繁！请稍后操作！',
    '300011': '抱歉！此手机号已被使用！请更换手机号！',
    '300012': '您已绑定过手机号，无需再次绑定！',
    '300013': '非本人手机号',
    '300014': '取消教师权限失败',
    '300015': '恢复教师权限失败',
    '400001': '系统更新！如一直呈现该状态，请联系工作人员！',
    '500010': '栏目下有新闻，不可删除',
    '500011': '栏目下，头条新闻不能超过5条',
    '520001': '新增广告超过10条',
    '520002': '发布中的广告不能被删除',
    '520003': '下架广告必须剩下一条',
    '530001': '整体榜单尚未打开',
    '530002': '整体榜单打开中',
    '550001': '渠道筛选不到数据',
    '560001': '新增赛事超过10条',
    '560002': '自动上下架时间必须同时存在',
    '570001': '用户非初次设置密码',
    '550002': '渠道已经存在，不能重复提交',
    '610000': '用户不能绑定新的单位',
    '620000': '保存单位课程失败',
    '620001': '取消单位课程失败',
    '621001': '添加学生课程失败',
    '621002': '取消学生课程失败',
    '630000': '添加课程包记录失败',
    '630001': '更新失败',
    '630002': '添加课程失败',
    '630003': '更新课程失败',
    '630004': '更新课程介绍失败',
    '630005': '更新课程备注失败',
    '630006': '删除课程包记录失败',
    '630007': '课程包记录不存在',
    '630008': '创作工具与素材格式不一致，无法保存',
    '630009': '创作工具不在范围内',
    '630010': '创作工具必选',
    '630011': '课次超过200节',
    '630012': '删除课程失败',
    '630013': '发送课程失败',
    '630014': '课程包下有课程，无法删除',
    '700000': '作品评分失败',
    '910001': 'email已经注册了',
    '910005': 'email发送太频繁',
    '910006': 'email未注册',
    '400002': '名称需全中文或全英文，请检查格式是否正确',
    '400003': '该手机号已被绑定其他用户',
    '400004': '重置密码失败',
    '910007': '服务异常'
  },
  'zh-TW': {
    E_1: '非法token',
    '100000': '系統錯誤',
    '100001': '未找到該國家!',
    '100002': '未找到該省份!',
    '100003': '未找到該城市!',
    '100004': '未找到該區縣!',
    '100005': '驗證失敗，請檢查是否超時或驗證碼輸入是否正確!',
    '100006': '已發送驗證碼至手機，請及時查看!',
    '100007': '單位類型未找到!',
    '100008': '抱歉，未找到此帳號!',
    '100009': '該學生尚未登錄過未來教室，帳號未啟動，請先啟動再調整課堂表現分!',
    '100010': '為了您的帳號安全，請重新登錄！',
    '100011': '抱歉，未查詢到相應資料！',
    '100012': '提交資訊錯誤！請檢查再提交！',
    '100013': '驗證碼發送失敗!',
    '100014': '獲取失敗!',
    '100016': '未知異常!',
    '200001': '管理員帳號錯誤！',
    '200002': '管理員密碼錯誤！',
    '200004': '申請資訊未找到！',
    '200005': '單位未找到！',
    '200006': '該老師已存在！',
    '200007': '用戶未找到',
    '200008': '申請人是學生，不能提交哦！',
    '200009': '用戶名或密碼錯誤！',
    '200010': '抱歉！此申請已被處理過！',
    '200011': '未找到BCM文件!',
    '200012': '教管不能修改單位名稱',
    '200013': '批量添加學生超過50個，請檢查再添加',
    '210009': '用戶不存在',
    '210013': 'PID 錯誤',
    '210014': '用戶被鎖定',
    '210015': '賬號或密碼錯誤',
    '210016': '激活錯誤',
    '210017': '激活失效',
    '200014': '有帳號未找到，請檢查再添加',
    '300001': '抱歉！班級未找到！',
    '300002': '抱歉！您尚未有“未來教室”許可權！',
    '300003': '一次批量註冊學生人數需不超過100人哦 ！',
    '300004': '班級學生人數需不超過200人哦！',
    '300005': '抱歉！用戶已經存在於其他機構！',
    '300006': '此用戶非學生身份哦！',
    '300007': '學生已在當前班級！',
    '300008': '抱歉！您尚未有此許可權！',
    '300009': '抱歉！班級數需不超過200個哦！',
    '300010': '抱歉！您請求驗證碼過於頻繁！請稍後操作！',
    '300011': '抱歉！此手機號已被使用！請更換手機號！',
    '300012': '您已綁定過手機號，無需再次綁定！',
    '300013': '非本人手機號',
    '300014': '取消教師許可權失敗',
    '300015': '恢復教師許可權失敗',
    '400001': '系統更新！如一直呈現該狀態，請聯繫工作人員！',
    '500010': '欄目下有新聞，不可刪除',
    '500011': '欄目下，頭條新聞不能超過5條',
    '520001': '新增廣告超過10條',
    '520002': '發佈中的廣告不能被刪除',
    '520003': '下架廣告必須剩下一條',
    '530001': '整體榜單尚未打開',
    '530002': '整體榜單打開中',
    '550001': '管道篩選不到資料',
    '560001': '新增賽事超過10條',
    '560002': '自動上下架時間必須同時存在',
    '570001': '使用者非初次設置密碼',
    '550002': '管道已經存在，不能重複提交',
    '610000': '使用者不能綁定新的單位',
    '620000': '保存單位課程失敗',
    '620001': '取消單位課程失敗',
    '621001': '添加學生課程失敗',
    '621002': '取消學生課程失敗',
    '630000': '添加課程包記錄失敗',
    '630001': '更新失敗',
    '630002': '添加課程失敗',
    '630003': '更新課程失敗',
    '630004': '更新課程介紹失敗',
    '630005': '更新課程備註失敗',
    '630006': '刪除課程包記錄失敗',
    '630007': '課程包記錄不存在',
    '630008': '創作工具與素材格式不一致，無法保存',
    '630009': '創作工具不在範圍內',
    '630010': '創作工具必選',
    '630011': '課次超過200節',
    '630012': '刪除課程失敗',
    '630013': '發送課程失敗',
    '630014': '課程包下有課程，無法刪除',
    '700000': '作品評分失敗',
    '910001': 'email已經註冊了',
    '910005': 'email發送太頻繁',
    '910006': 'email未註冊',
    '400002': '用戶名不能有特殊字元',
    '400003': '該手機號已被綁定其他用戶',
    '400004': '重設密碼失敗',
    '910007': '服務異常'
  },
  it: {
    E_1: 'nonlicet token',
    '100000': 'System error.',
    '100001': 'The country was not found!',
    '100002': 'The province was not found!',
    '100003': 'The city was not found!',
    '100004': 'The district was not found!',
    '100005':
      'Failed to verify. Please check if the time is out or verification code is correct!',
    '100006':
      'A verification code has been sent to the phone, please check it!',
    '100007': 'Organization type was not found!',
    '100008': 'Sorry, this account was not found!',
    '100009':
      'The student account is not activated. Please log in to the Future Classroom to activate it before adjusting the classroom performance score!',
    '100010': 'For your account security, please log in again!',
    '100011': 'Sorry, the data is not found!',
    '100012': 'Submission of wrong information! Please check and submit again!',
    '100013': 'Failed to send verification code!',
    '100014': 'Failed to access!',
    '100016': 'Unknown exception!',
    '200001': 'The administrator account is wrong!',
    '200002': 'The administrator password is wrong!',
    '200004': 'Application information not found!',
    '200005': 'Organization not found!',
    '200006': 'The teacher already exists!',
    '200007': 'User not found.',
    '200008': 'The applicant is a student and cannot be submitted!',
    '200009': 'Wrong username or password!',
    '200010': 'Sorry! This application has been processed!',
    '200011': 'Bcm file not found!',
    '200012': 'Tutor cannot modify the name of the organization.',
    '200013': 'Add more than 50 students at a time, please check and add.',
    '210009': 'User not found.',
    '210013': 'PID error',
    '210014': 'User is locked',
    '210015': 'Wrong account or password',
    '210016': 'Error activation',
    '210017': 'Activation failure',
    '300001': 'Sorry! Class is not found!',
    '300002': 'Sorry! You do not have the Future Classroom permission!',
    '300003': 'The number of registration students should not exceed 100!',
    '300004': 'The number of students in each class should not exceed 200!',
    '300005': 'Sorry! The user already exists in other institutions!',
    '300006': 'This user is not a student!',
    '300007': 'The student is already in the current class!',
    '300008': 'Sorry! You do not have this permission yet!',
    '300009': 'Sorry! The number of class should not exceed 200!',
    '300010':
      'Sorry! You requested a verification code too often! Please try again later!',
    '300011':
      'Sorry! This phone number has been used! Please change your mobile number!',
    '300012':
      "You have already bound your phone number and don't need to do it again!",
    '300013': 'Not your mobile phone number.',
    '300014': 'Failed to cancel teacher permission.',
    '300015': 'Failed to restore teacher permission.',
    '400001':
      'System updating! If the system is always in this status, please contact the staff!',
    '500010': 'There is news under the column. It cannot be deleted.',
    '500011': 'Under the column, the headline news cannot exceed 5.',
    '520001': 'There are more than 10 new ads.',
    '520002': 'Ads which is publishing cannot be deleted.',
    '520003': 'There must be one left for the removed advertisement.',
    '530001': 'The overall list is not open yet.',
    '530002': 'The overall list is open.',
    '550001': 'Channel can not filter data.',
    '560001': 'There are more than 10 new events.',
    '560002': 'Automatic removal/published time must exist at the same time.',
    '570001': 'User does not set password for the first time.',
    '550002': 'The channel already exists and cannot be submitted repeatedly.',
    '610000': 'User cannot bind new organization.',
    '620000': 'Failed to save organization course.',
    '620001': 'Failed to cancel organization course.',
    '621001': 'Failed to add student course.',
    '621002': 'Failed to cancel student course.',
    '630000': 'Failed add a course package record.',
    '630001': 'Failed to update.',
    '630002': 'Failed to add course.',
    '630003': 'Failed to update course.',
    '630004': 'Failed to update course introduction.',
    '630005': 'Failed to update course notes.',
    '630006': 'Failed to delete course package record.',
    '630007': 'Course package record does not exist.',
    '630008':
      'The creating tool is inconsistent with the material format and cannot be saved.',
    '630009': 'Creating tool unavailable.',
    '630010': 'Creating tools required.',
    '630011': 'This course has more than 200 sessions.',
    '630012': 'Failed to delete course.',
    '630013': 'Failed to send course.',
    '630014': 'The course package has courses and cannot be deleted.',
    '700000': 'Failed to grade.',
    '910001': 'email has been enrolled',
    '910005': 'email sending too often',
    '910006': 'email not registered',
    '400002': 'Username cannot have special characters.',
    '400003': 'The phone number has been bound to other user.',
    '400004': 'Failed to reset password.',
    '910007': 'Service exception'
  },
  id: {
    E_1: 'token list',
    '100000': 'Kesalahan sistem.',
    '100001': 'Negara tidak ditemukan!',
    '100002': 'Provinsi tidak ditemukan!',
    '100003': 'Kota tidak ditemukan!',
    '100004': 'Distrik tidak ditemukan!',
    '100005': 'Verifikasi gagal. Silakan periksa apakah waktunya habis atau kode verifikasi salah! ',
    '100006': 'Kode verifikasi telah dikirim melalui nomor telepon anda, silakan periksa!',
    '100007': 'Jenis organisasi tidak ditemukan!',
    '100008': 'Maaf, akun ini tidak ditemukan!',
    '100009': 'Akun siswa belum diaktifkan. Silakan masuk ke Kelas Masa Depan untuk mengaktifkan akun sebelum menyesuaikan skor kinerja kelas! ',
    '100010': 'Untuk keamanan akun Anda, silakan masuk lagi!',
    '100011': 'Maaf, data tidak ditemukan!',
    '100012': 'Informasi salah! Silakan periksa dan kirim kembali! ',
    '100013': 'Gagal mengirim kode verifikasi!',
    '100014': 'Gagal mengakses!',
    '100016': 'Pengecualian tidak diketahui!',
    '200001': 'Akun Administrator salah!',
    '200002': 'Kata sandi administrator salah!',
    '200004': 'Informasi aplikasi tidak ditemukan!',
    '200005': 'Organisasi tidak ditemukan!',
    '200006': 'Guru sudah terdaftar!',
    '200007': 'Pengguna tidak ditemukan.',
    '200008': 'Pelamar adalah mahasiswa dan tidak dapat diajukan!',
    '200009': 'Nama pengguna atau kata sandi salah!',
    '200010': 'Maaf! Aplikasi ini sudah diproses sebelumnya! ',
    '200011': 'File Bcm tidak ditemukan!',
    '200012': 'Guru tidak dapat mengubah nama organisasi.',
    '200013': 'Tambahkan lebih dari 50 siswa sekaligus, silakan periksa dan tambahkan.',
    '210009': 'Pengguna tidak ditemukan.',
    '210013': 'Kesalahan PID',
    '210014': 'Akun pengguna terkunci',
    '210015': 'Akun atau kata sandi salah',
    '210016': 'Aktivasi salah',
    '210017': 'Kegagalan aktivasi',
    '300001': 'Maaf! Kelas tidak ditemukan! ',
    '300002': 'Maaf! Anda tidak memiliki izin Kelas Masa Depan! ',
    '300003': 'Jumlah siswa yang terdaftar tidak boleh melebihi 100!',
    '300004': 'Jumlah siswa di setiap kelas tidak boleh melebihi 200!',
    '300005': 'Maaf! Pengguna sudah terdaftar di institusi lain! ',
    '300006': 'Pengguna ini bukan pelajar!',
    '300007': 'Siswa sudah terdaftar di kelas ini!',
    '300008': 'Maaf! Anda belum memiliki izin ini! ',
    '300009': 'Maaf! Jumlah kelas tidak boleh melebihi 200! ',
    '300010': 'Maaf! Anda terlalu sering meminta kode verifikasi! Silakan tunggu dan coba lagi nanti! ',
    '300011': 'Maaf! Nomor telepon ini telah digunakan! Silakan ubah nomor ponsel Anda! ',
    '300012': 'Anda sudah berhasil mendaftarkan nomor telepon Anda dan tidak perlu melakukannya lagi!',
    '300013': 'Bukan nomor ponsel Anda.',
    '300014': 'Gagal membatalkan izin guru.',
    '300015': 'Gagal mengembalikan izin guru.',
    '400001': 'Pembaruan sistem! Jika sistem terus berada dalam status ini, silakan hubungi staf! ',
    '500010': 'Ada berita di bawah kolom. Itu tidak bisa dihapus. ',
    '500011': 'Di bawah kolom, berita utama tidak boleh melebihi 5.',
    '520001': 'Ada lebih dari 10 iklan baru.',
    '520002': 'Iklan yang sedang menerbitkan tidak dapat dihapus.',
    '520003': 'Harus ada yang tersisa untuk iklan yang dihapus.',
    '530001': 'Daftar keseluruhan belum terbuka.',
    '530002': 'Daftar keseluruhan terbuka.',
    '550001': 'Saluran tidak dapat menyaring data.',
    '560001': 'Ada lebih dari 10 acara baru.',
    '560002': 'Penghapusan otomatis / waktu yang dipublikasikan harus ada pada saat yang sama.',
    '570001': 'Pengguna tidak menetapkan kata sandi untuk pertama kalinya.',
    '550002': 'Saluran sudah ada dan tidak dapat dikirimkan berulang kali.',
    '610000': 'Pengguna tidak dapat mengikat organisasi baru.',
    '620000': 'Gagal menyelamatkan kursus organisasi.',
    '620001': 'Gagal membatalkan kursus organisasi.',
    '621001': 'Gagal menambah kursus siswa.',
    '621002': 'Gagal membatalkan kursus siswa.',
    '630000': 'Gagal menambahkan catatan paket kursus.',
    '630001': 'Gagal memperbarui.',
    '630002': 'Gagal menambahkan kursus.',
    '630003': 'Gagal memperbarui kursus.',
    '630004': 'Gagal memperbarui pengenalan kursus.',
    '630005': 'Gagal memperbarui catatan kursus.',
    '630006': 'Gagal menghapus catatan paket kursus.',
    '630007': 'Catatan paket kursus tidak ada.',
    '630008': 'Alat pembuatan tidak konsisten dengan format materi dan tidak dapat disimpan.',
    '630009': 'Membuat alat tidak tersedia.',
    '630010': 'Membuat alat diperlukan.',
    '630011': 'Kursus ini memiliki lebih dari 200 sesi.',
    '630012': 'Gagal menghapus kursus.',
    '630013': 'Gagal mengirim kursus.',
    '630014': 'Paket kursus memiliki kursus dan tidak dapat dihapus.',
    '700000': 'Gagal peringkat.',
    '910001': 'Email telah terdaftar',
    '910005': 'Pengiriman email terlalu sering',
    '910006': 'Email tidak terdaftar',
    '400002': 'Nama pengguna tidak boleh memiliki karakter khusus.',
    '400003': 'Nomor telepon telah didaftarkan pengguna lain.',
    '400004': 'Gagal me-reset kata sandi.',
    '910007': 'Pengecualian layanan'
  }
}
